module.exports = __webpack_public_path__ + "img/szw4.faa9d7eb.jpg";